import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";

// TODO: review usage of @loadable which is having issues with Qiankun
import Map from "pages/Map";
import NotFound from "components/common/NotFound";

import { CameraAuth } from "pages/Settings/Camera/Camera";
import { IncidentTypeAuth } from "pages/Settings/IncidentType/IncidentType";
import { IncidentTypeAddAuth } from "pages/Settings/IncidentType/AddIncidentType/AddIncidentType";
import { CategoryAuth } from "pages/Settings/IncidentType/Category/Category";
import { SubcategoryAuth } from "pages/Settings/IncidentType/Subcategory/Subcategory";
import { IncidentAuth } from "pages/Settings/Incident/Incident";
import { IncidentAddAuth } from "pages/Settings/Incident/Add/Add";
import { PriorityAuth } from "pages/Settings/Incident/Priority/Priority";
import { SeverityAuth } from "pages/Settings/Incident/Severity/Severity";
import { IncidentEditAuth } from "pages/Settings/Incident/Edit/Edit";
import { SopAddAuth } from "pages/Settings/Sop/SopAdd/SopAdd";
import { SopEditAuth } from "pages/Settings/Sop/SopEdit/SopEdit";
import { WorkflowAuth } from "pages/Settings/Workflow/Workflow";
import { WorkflowAddAuth } from "pages/Settings/Workflow/AddEdit/Add";
import { WorkflowEditAuth } from "pages/Settings/Workflow/AddEdit/Edit";
import { UsersAuth } from "pages/Settings/Users/Users";
import { UserAddAuth } from "pages/Settings/Users/Add/Add";
import { UserEditAuth } from "pages/Settings/Users/Edit/Edit";
import { CameraAddAuth } from "pages/Settings/Camera/Add/Add";
import { CameraEditAuth } from "pages/Settings/Camera/Edit/Edit";
import { SopAuth } from "pages/Settings/Sop/Sop";
import { StatusAuth } from "pages/Settings/Incident/Status/Status";
import { IncidentTypeEditAuth } from "pages/Settings/IncidentType/EditIncidentType/EditIncidentType";
import { ListIncidentAuth } from "pages/List/Incident/Incident";
import { ListAuth } from "pages/List/List";
import BaseRoute from "./BaseRoute";

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" exact>
        <Redirect to="/settings" />
      </Route>

      <BaseRoute path="/map" component={Map} />

      <BaseRoute path="/incidents" component={ListAuth} exact />
      <BaseRoute
        path="/incidents/:id"
        component={ListIncidentAuth}
        useErrorBoundary
      />

      <Route path="/settings" exact>
        <Redirect to="/settings/camera" />
      </Route>

      <BaseRoute
        exact
        path="/settings/incident-type"
        component={IncidentTypeAuth}
      />
      <BaseRoute
        exact
        path="/settings/incident-type/add"
        component={IncidentTypeAddAuth}
      />
      <BaseRoute
        path="/settings/incident-type/category"
        component={CategoryAuth}
      />
      <BaseRoute
        path="/settings/incident-type/subcategory"
        component={SubcategoryAuth}
      />
      <BaseRoute
        path="/settings/incident-type/:id"
        component={IncidentTypeEditAuth}
        useErrorBoundary
      />
      <BaseRoute exact path="/settings/incident" component={IncidentAuth} />
      <BaseRoute path="/settings/incident/add" component={IncidentAddAuth} />
      <BaseRoute path="/settings/incident/priority" component={PriorityAuth} />
      <BaseRoute path="/settings/incident/status" component={StatusAuth} />
      <BaseRoute path="/settings/incident/severity" component={SeverityAuth} />
      <BaseRoute
        path="/settings/incident/:id"
        component={IncidentEditAuth}
        useErrorBoundary
      />

      <BaseRoute exact path="/settings/sop" component={SopAuth} />
      <BaseRoute path="/settings/sop/add" component={SopAddAuth} />
      <BaseRoute
        path="/settings/sop/:id"
        component={SopEditAuth}
        useErrorBoundary
      />

      <BaseRoute exact path="/settings/workflow" component={WorkflowAuth} />

      <BaseRoute path="/settings/workflow/add" component={WorkflowAddAuth} />

      <BaseRoute
        path="/settings/workflow/:id"
        component={WorkflowEditAuth}
        useErrorBoundary
      />

      <BaseRoute
        exact
        path="/settings/users"
        component={UsersAuth}
        useErrorBoundary
      />
      <BaseRoute
        exact
        path="/settings/users/add"
        component={UserAddAuth}
        useErrorBoundary
      />
      <BaseRoute
        exact
        path="/settings/users/edit/:id"
        component={UserEditAuth}
        useErrorBoundary
      />

      <BaseRoute
        exact
        path="/settings/camera"
        component={CameraAuth}
        useErrorBoundary
      />
      <BaseRoute
        exact
        path="/settings/camera/add"
        component={CameraAddAuth}
        useErrorBoundary
      />

      <BaseRoute
        path="/settings/camera/edit/:id"
        component={CameraEditAuth}
        useErrorBoundary
      />

      <Route component={NotFound} />
    </Switch>
  );
};

export default Routes;
